import React from "react"

interface GoodleapTpoUnavailableAlertProps {
  loanProductTypes: string[]
  className?: string
}

export const GoodleapTpoUnavailableAlert: React.FC<
  GoodleapTpoUnavailableAlertProps
> = ({ loanProductTypes, className = `mb-4` }) => {
  if (!loanProductTypes.length) {
    return null
  }

  return (
    <div
      className={`${className} rounded-lg border border-blue-200 bg-blue-50 px-4 py-3`}
    >
      <div className="flex items-start gap-2">
        <svg
          className="h-5 w-5 flex-shrink-0 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div>
          <p className="text-sm font-medium text-blue-900">
            GoodLeap does not offer TPO products in this state and/or utility
            with the current equipment selection(s).
          </p>
          <p className="mt-1 text-xs text-blue-700">
            {`TPO products are available for the following configuration(s): `}
            {loanProductTypes.map((loanProductType, index) => (
              <React.Fragment key={loanProductType}>
                {formatItem(loanProductType, index, loanProductTypes)}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </div>
  )
}

const formatItem = (item: string, index: number, array: string[]) => {
  if (index === array.length - 1) {
    return item
  }
  if (index === array.length - 2) {
    return (
      <>
        {item}
        <span> or </span>
      </>
    )
  }

  return (
    <>
      {item}
      <span>, </span>
    </>
  )
}
